import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import NotificationProvider from "components/NotificationProvider";
import DOMPurify from "dompurify";
import { useSendVendorEmailMutation } from "./vendorDetachedTemplateSlice";
import { vendorDetachedEmailDialogStyle } from "./VendorDetachedEmailDialogStyles";

const VendorDetachedEmailDialog = ({ open, onClose, emailDraft, activityLogId }) => {
    const classes = vendorDetachedEmailDialogStyle();
    const [sendEmail, { isLoading }] = useSendVendorEmailMutation();

    const handleSend = async () => {
        const res = await sendEmail({
            vendorId: emailDraft.vendorId,
            workOrderId: activityLogId,
            templateSubject: emailDraft.subject,
            templateBody: emailDraft.body,
        });
        if (res?.error) {
            NotificationProvider.error('Failed to send vendor email');
        } else {
            NotificationProvider.success('Vendor email sent');
        }
        onClose();
    };

    if (!emailDraft) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Send Vendor Notification Email</DialogTitle>
            <DialogContent>
                <div className={classes.fieldLabel}>To</div>
                <div className={classes.fieldValue}>{emailDraft.recipientEmails?.join(', ') || '—'}</div>
                <div className={classes.fieldLabel}>Subject</div>
                <div className={classes.fieldValue}>{emailDraft.subject}</div>
                <div className={classes.fieldLabel}>Body</div>
                <div
                    className={classes.bodyPreview}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(emailDraft.body) }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Dismiss</Button>
                <Button onClick={handleSend} color="primary" variant="contained" disabled={isLoading}>
                    Send
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VendorDetachedEmailDialog;
